export default __webpack_public_path__ + "static/media/01-abnormal.2513590d.mp4";